import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Layout from '@/components/Layout';
import SEO from '@/components/SEO';
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  // Schema.org עבור דף שגיאה 404
  const notFoundSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "דף לא נמצא | טכנולוגיה פשוטה",
    "description": "העמוד המבוקש לא נמצא. אנא נסה לחפש או חזור לדף הבית.",
    "publisher": {
      "@type": "Organization",
      "name": "טכנולוגיה פשוטה"
    }
  };

  return (
    <>
      <SEO 
        title="דף לא נמצא (404) | טכנולוגיה פשוטה"
        description="העמוד שחיפשת לא נמצא. ייתכן שהוא הוסר, שונה או שהכתובת הוקלדה בצורה שגויה."
        canonicalUrl="/404"
        structuredData={notFoundSchema}
      />
      <Layout>
        <div className="sr-only" id="main-content">עמוד השגיאה מתחיל כאן</div>
        <main id="main-content" role="main" aria-labelledby="error-heading" className="min-h-screen flex items-center justify-center bg-tech-gray py-12">
          <div className="container mx-auto px-6 text-center">
            <div className="bg-white rounded-xl p-8 shadow-sm max-w-lg mx-auto">
              <h1 id="error-heading" className="text-6xl font-bold text-tech-blue mb-6">404</h1>
              <p className="text-2xl text-tech-darkGray mb-4">העמוד לא נמצא</p>
              <p className="text-gray-600 mb-8">
                העמוד שחיפשת אינו קיים או שהועבר לכתובת אחרת.
              </p>
              <div className="space-y-4">
                <Button
                  onClick={() => window.location.href = '/'}
                  className="bg-tech-blue hover:bg-tech-blue/90 text-white font-medium py-2 px-6 rounded-lg transition-all-200"
                  aria-label="חזור לדף הבית"
                >
                  חזור לדף הבית
                </Button>
                
                <div className="pt-6 border-t mt-6">
                  <p className="text-gray-600 text-sm">
                    אם אתה מאמין שזו שגיאה, אנא <a href="/contact" className="text-tech-blue hover:underline">צור קשר</a> עם צוות התמיכה שלנו.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </main>
      </Layout>
    </>
  );
};

export default NotFound;